import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { Overlay } from '~/ui/overlay/Overlay';
import { Modal } from '~/ui/modal/Modal';

const Title = styled.h3`
  margin: 0 0 16px 0;
  font-family: Raleway;
  font-size: 18px;
  font-weight: 600;
`;

const Message = styled.p`
  margin: 0 0 24px 0;
  font-family: Raleway;
  font-size: 14px;
  color: #666;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

const Button = styled.button<{ variant?: 'primary' | 'secondary' }>`
  padding: 8px 16px;
  border-radius: 4px;
  font-family: Raleway;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  
  ${props => {
    switch (props.variant) {
      case 'primary':
        return `
          background: #9738ff;
          color: white;
          
          &:hover {
            background: #7a2dcc;
          }
        `;
      case 'secondary':
        return `
          background: #f3ecff;
          color: #7a2dcc;
          
          &:hover {
            background: #e5e5e5;
          }
        `;
      default:
        return `
          background: #f5f5f5;
          color: #333;
          
          &:hover {
            background: #e5e5e5;
          }
        `;
    }
  }}
`;

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Delete',
  message = 'Are you sure you want to delete this item? This action cannot be undone.'
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return ReactDOM.createPortal(
    <Overlay open={isOpen} opacity={0.5} onClick={onClose}>
      <div onClick={e => e.stopPropagation()}>
        <Modal 
          open={true} 
          width="350px" 
          horizontal="center" 
          vertical="center" 
          padding="24px"
        >
          <div onClick={e => e.stopPropagation()}>
            <Title>{title}</Title>
            <Message>{message}</Message>
            <ButtonGroup>
              <Button variant="secondary" onClick={(e) => {
                e.stopPropagation();
                console.log('Cancel clicked');
                onClose();
              }}>Cancel</Button>
              <Button variant="primary" onClick={(e) => {
                e.stopPropagation();
                console.log('Delete button clicked');
                handleConfirm();
              }}>Delete</Button>
            </ButtonGroup>
          </div>
        </Modal>
      </div>
    </Overlay>,
    document.body
  );
};

export default ConfirmModal; 